import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { settings, Settings } from 'app/core/settings';
import { PrefixUrlHostedArray } from 'app/core/shared/enum/prefix-url-hosted-enum';
import { PrefixApiPortalEnum } from 'app/core/shared/enum/prefix-api-portal-enum';

@Component({
  selector: 'change-region',
  templateUrl: 'change-region.component.html',
  styleUrls: ['change-region.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeRegionComponent {

  prefixUrlHosted = PrefixUrlHostedArray;
  prefixApiPortalEnum = PrefixApiPortalEnum;

  showLinkUrlHosted(value: string): boolean {
    return !(value === this.prefixUrlHostedSettings);
  }

  get urlHosted(): string {
    const hostedName = this.prefixUrlHosted.find(value => {
      return value.key === this.prefixUrlHostedSettings
    });
    return hostedName.value || 'Undefined';
  }

  get prefixUrlHostedSettings(): string {
    return this.settings.сloudSite.name.split('.')[0];
  }

  get settings(): Settings {
    return settings;
  }

  constructor(private dialogService: UIDialogService) { }

  closeDialog(): void {
    this.dialogService.close();
  }
}
